export const TIME_CONSTANTS = {
  ONE_SECOND: 1000,
  ONE_MIN: 1000 * 60,
  THIRTY_MIN: 30 * 60 * 1000,
  ONE_HOUR: 60 * 60 * 1000,
  ONE_MINUTE_IN_SECONDS: 60,
};
